/* eslint-disable indent,no-new,no-undef,valid-jsdoc */
import axios from 'axios'
import {
  FETCH_REVIEW_ANALYTICS,
  FETCH_REVIEW_ANALYTICS_STATS,
  FETCH_REVIEW_ANALYTICS_GRAPH,
  FETCH_REVIEW_ANALYTICS_USAGE,
  FETCH_REVIEW_INVITE_ANALYTICS_STATS,
  FETCH_REVIEW_INVITE_ANALYTICS_GRAPHS,
  FETCH_REVIEW_INVITE_CONVERSION_ANALYTICS_GRAPHS
} from '@/store/action.types'
import {
  SET_REVIEW_ANALYTICS_DATA
} from '@/store/mutation.types'

/**
 * Whether want to namespace it ot not
 * @type {boolean}
 */
export const namespaced = true

/**
 * State related to Review Analytics Statistics
 * @type {Object}
 */
export const state = {
  starRatings: [],
  reviewUsage: {},
  responseRates: {},
  reviewInvites: {
    stats: {},
    graphs: {
      invites: [],
      conversions: []
    }
  }
}

/**
 * Actions related to Review Analytics Statistics
 * @type {Object}
 */
export const actions = {
  /**
   * Fetching the review analytics data for graph
   * @param {function} commit
   * @param {object} payload
   * @return {Promise}
   */
  [FETCH_REVIEW_ANALYTICS_GRAPH] ({commit}, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`/analytics/${payload.businessSlug}/reviews/graph`, {
        params: Object.assign(payload, {
          track_activity_action: 'reviews.analytics.view',
          track_activity_event: 'ReviewAnalyticsActivityGraph'
        })
      })
      .then(({data: {data: stats}}) => {
        resolve(stats)
        commit(SET_REVIEW_ANALYTICS_DATA, stats)
      })
      .catch((error) => {
        reject(error)
      })
    })
  },
  /**
   * Fetching the review analytics data
   * @param {function} commit
   * @param {object} payload
   * @return {Promise}
   */
  [FETCH_REVIEW_ANALYTICS] ({commit}, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`/analytics/${payload.businessSlug}/reviews`, {
        params: Object.assign(payload, {
          track_activity_action: 'reviews.analytics.view',
          track_activity_event: 'ReviewAnalyticsActivity'
        })
      })
      .then(({data: {data: ratings}}) => {
        resolve()
        commit(SET_REVIEW_ANALYTICS_DATA, ratings)
      })
      .catch((error) => {
        reject(error)
      })
    })
  },
  /**
   * Fetching the review analytics stats
   * @param {function} commit
   * @param {object} payload
   * @return {Promise}
   */
  [FETCH_REVIEW_ANALYTICS_STATS] ({commit}, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`/analytics/${payload.businessSlug}/reviews/rates`, {
        params: Object.assign(payload, {
          track_activity_action: 'reviews.analytics.view',
          track_activity_event: 'ReviewAnalyticsActivity'
        })
      })
      .then(({data: {data: stats}}) => {
        resolve(stats)
        commit(SET_REVIEW_ANALYTICS_DATA, stats)
      })
      .catch((error) => {
        reject(error)
      })
    })
  },
  /**
   * Fetching the review analytics usage
   * @param {function} commit
   * @param {object} payload
   * @return {Promise}
   */
  [FETCH_REVIEW_ANALYTICS_USAGE] ({commit}, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`/analytics/${payload.businessSlug}/reviews/usage`, {
        params: Object.assign(payload, {
          track_activity_action: 'reviews.analytics.view',
          track_activity_event: 'ReviewAnalyticsActivityUsage'
        })
      })
      .then(({data: {data: stats}}) => {
        resolve()
        commit(SET_REVIEW_ANALYTICS_DATA, stats)
      })
      .catch((error) => {
        reject(error)
      })
    })
  },
  /**
   * Fetching the review analytics stats for Invite analytics
   * @param {function} commit
   * @param {object} state
   * @param {object} payload
   * @return {Promise}
   */
  [FETCH_REVIEW_INVITE_ANALYTICS_STATS] ({commit, state}, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`/analytics/${payload.businessSlug}/reviews/invites`, {
        params: Object.assign(payload, {
          track_activity_action: 'reviews.analytics.view',
          track_activity_event: 'ReviewInviteAnalyticsActivityUsage'
        })
      })
      .then(({data: {data: response}}) => {
        commit(SET_REVIEW_ANALYTICS_DATA, {
          reviewInvites: {
            graphs: {...state.reviewInvites.graphs},
            stats: response.stats
          }
        })
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
    })
  },
  /**
   * Fetching the review analytics stats for Invite analytics
   * @param {function} commit
   * @param {object} state
   * @param {object} payload
   * @return {Promise}
   */
  [FETCH_REVIEW_INVITE_ANALYTICS_GRAPHS] ({commit, state}, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`/analytics/${payload.businessSlug}/reviews/invites/graphs`, {
        params: Object.assign(payload, {
          track_activity_action: 'reviews.analytics.view',
          track_activity_event: 'ReviewInviteAnalyticsActivity'
        })
      })
      .then(({data: {data: response}}) => {
        commit(SET_REVIEW_ANALYTICS_DATA, {
          reviewInvites: {
            stats: {...state.reviewInvites.stats},
            graphs: {
              invites: response.invites,
              conversions: state.reviewInvites.graphs.conversions
            }
          }
        })
        resolve()
      })
      .catch((error) => {
        reject(error)
      })
    })
  },
  /**
   * Fetching the review analytics stats for Invite analytics
   * @param {function} commit
   * @param {object} state
   * @param {object} payload
   * @return {Promise}
   */
  [FETCH_REVIEW_INVITE_CONVERSION_ANALYTICS_GRAPHS] ({commit, state}, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`/analytics/${payload.businessSlug}/reviews/invites-conversion/graphs`, {
        params: Object.assign(payload, {
          track_activity_action: 'reviews.analytics.view',
          track_activity_event: 'ReviewInviteAnalyticsActivity'
        })
      })
      .then(({data: {data: response}}) => {
        commit(SET_REVIEW_ANALYTICS_DATA, {
          reviewInvites: {
            stats: {...state.reviewInvites.stats},
            graphs: {
              invites: state.reviewInvites.graphs.invites,
              conversions: response.conversions
            }
          }
        })
        resolve()
      })
      .catch((error) => {
        reject(error)
      })
    })
  }
}

/**
 * Mutations related to Review Analytics Statistics
 * @type {Object}
 */
export const mutations = {
  /**
   * Set the state for review analytics statistics
   * @param {object} state
   * @param {object} payload
   * @return {void}
   */
  [SET_REVIEW_ANALYTICS_DATA] (state, payload) {
    Object.assign(state, payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/analytics.js